import { Api } from "@/core/api.js";
import i18n from "@/i18n";
const api = new Api();

// initial state
const state = {
  list: [],
  contact_types: [],
  player_positions: [],
  alergies: [],
  campus_selected: false,
  total_list: 0,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {},
};

// getters
const getters = {
  getList: (state, getters, rootState) => (type) => {
    // console.log('getList')
    // console.log(state.list)
    var aPersons = [];
    for (var i in state.list) {
      if (
        typeof state.list[i].current_roles !== "undefined" &&
        typeof state.list[i].current_roles[0] !== "undefined"
      ) {
        state.list[i].contact_type =
          state.list[i].current_roles[0].contact_type;
        if (typeof state.list[i].current_roles[0] !== "undefined") {
          if (state.list[i].current_roles[0].club != null) {
            state.list[i].entity = state.list[i].current_roles[0].club;
            state.list[i].entity.type = "club";
          } else if (state.list[i].current_roles[0].hotel != null) {
            state.list[i].entity = state.list[i].current_roles[0].hotel;
            state.list[i].entity.type = "hotel";
          } else if (state.list[i].current_roles[0].facility != null) {
            state.list[i].entity = state.list[i].current_roles[0].facility;
            state.list[i].entity.type = "facility";
          } else if (state.list[i].current_roles[0].team != null) {
            state.list[i].entity = state.list[i].current_roles[0].team;
            state.list[i].entity.type = "team";
          } else if (state.list[i].current_roles[0].company != null) {
            state.list[i].entity = state.list[i].current_roles[0].company;
            state.list[i].entity.type = "company";
          } else if (state.list[i].current_roles[0].event != null) {
            state.list[i].entity = state.list[i].current_roles[0].event;
            state.list[i].entity.type = "event";
          }
          //   console.log(rootState.events.current_event)
          if (
            typeof rootState.events.current_event.id !== "undefined" &&
            rootState.events.current_event.is_campus
          ) {
            state.list[i].campus = [];
            state.list[i].campus_date = [];

            state.list[i].current_roles.forEach((c) => {
              if (
                ((typeof c.contact_type !== "undefined" &&
                  c.contact_type.id == "aXFZalgzRzFTeTVHZDVyWWIrei9uZz09") ||
                  c.contact_type_id == "aXFZalgzRzFTeTVHZDVyWWIrei9uZz09") &&
                c.event.id == rootState.events.current_event.id
              ) {
                // console.log(state.list[i].name, state.list[i].status, state.list[i].status_participant)
                state.list[i].status = c.status;
                state.list[i].status_participant = c.status_participant;
                state.list[i].lottery = c.campus_lottery;
                state.list[i].lottery_send = c.campus_lottery_send;
                state.list[i].bus = c.campus_bus;
                state.list[i].pickup = c.campus_pickup;
                state.list[i].returnit = c.campus_returnit;
                state.list[i].image_right = c.campus_image_right_status;
                state.list[i].campus_id = c.campus_id;
                state.list[i].campus_date.push(
                  moment(
                    rootState.events.current_event.campus[c.campus_id]
                      .start_date
                  ).format("DD/MM/YYYY") +
                    " - " +
                    moment(
                      rootState.events.current_event.campus[c.campus_id]
                        .end_date
                    ).format("DD/MM/YYYY")
                );
                state.list[i].campus_type = c.campus_type_id;
                state.list[i].campus_modality = c.campus_modality;
                state.list[i].campus_code = c.code;
                state.list[i].campus_position = c.campus_goalkeeper;

                state.list[i].campus.push({
                  name: c.campus_name,
                  start_date: c.campus_start_date,
                  end_date: c.campus_end_date,
                });
                state.list[i].inscription_date = c.creation_date;
                state.list[i].budget = c.budget;
              }
            });
          }
        }
      } else {
        state.list[i].contact_type = { id: -1, name: i18n.t("not_role") };
        state.list[i].entity = { type: null };
      }

      if (state.list[i].visible) aPersons.push(state.list[i]);
    }

    return aPersons;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getListNoFiltered: (state, getters, rootState) => () => {
    var aPersons = [];
    for (var i in state.list) {
      aPersons.push(state.list[i]);
    }
    return aPersons;
  },

  get_by_id: (state, getters, rootState) => (id) => {
    if (typeof state.list[id] !== "undefined") {
      var person = JSON.parse(JSON.stringify(state.list[id]));
      for (var k in person) {
        if (person[k] == "true") person[k] = true;
        else if (person[k] == "false") person[k] = false;
        else if (
          parseInt(person[k]) == person[k] &&
          parseInt(person[k]).length == person[k].length
        )
          person[k] = parseInt(person[k]);
      }

      return person;
    }
    return false;
  },

  getContactTypes: (state, getters, rootState) => (type) => {
    if (typeof type === "undefined" || !type) {
      return ObjectToArray(state.contact_types);
    } else {
      var aContactTypes = [];
      for (var key in state.contact_types) {
        var contact_type = state.contact_types[key];
        if (parseInt(contact_type.type) == type) {
          aContactTypes.push(contact_type);
        }
      }

      return aContactTypes;
    }
  },

  getContactTypeById: (state, getters, rootState) => (id) => {
    // console.log( "getContactType -- " + type );
    var contact_type = {};
    for (var k in state.contact_types) {
      if (id == k) {
        contact_type = state.contact_types[k];
      }
    }

    return contact_type;
  },

  getGlobalTypes: (state, getters, rootState) => () => {
    return [
      { id: 1, name: "persons.competition" },
      { id: 2, name: "persons.partners" },
      { id: 3, name: "persons.logistic" },
      { id: 4, name: "persons.leads" },
    ];
  },

  getPositions: (state, getters, rootState) => () => {
    return state.player_positions;
  },

  getPosition: (state, getters, rootState) => (id) => {
    return state.player_positions[id];
  },

  getAlergies: (state, getters, rootState) => () => {
    return state.alergies;
  },

  getGenders: (state, getters, rootState) => () => {
    return [
      { name: "gender.male", id: 1 },
      { name: "gender.female", id: 2 },
      { name: "gender.other", id: 3 },
    ];
  },

  getStatusDocuments: (state, getters, rootState) => (id) => {
    var status = [
      { id: null, name: i18n.t("documents.status_0") },
      { id: "1", name: i18n.t("documents.status_1") },
      { id: "2", name: i18n.t("documents.status_2") },
      { id: "3", name: i18n.t("documents.status_3") },
    ];

    if (typeof id !== "undefined") {
      var ret = false;
      status.forEach((stat) => {
        if (stat.id == id) {
          ret = stat;
        }
      });

      return ret;
    }

    return status;
  },
};

// actions
const actions = {
  loadList(context, params) {
    var page =
      typeof params.page !== "undefined"
        ? params.page
        : context.rootState.current_page;

    var path =
      "person" +
      (typeof params.submenu !== "undefined"
        ? "/type/" + params.submenu
        : page == "participants"
        ? "/type/participants"
        : "") +
      (typeof params.event !== "undefined" ? "/event/" + params.event : "");

    var page_options =
      params && params.page_options
        ? params.page_options
        : context.state.pagination;
    var filters =
      params && params.filters ? params.filters : state.current_filters;
    var oParams = Object.assign(filters ? filters : {}, page_options);
    return api.post(path, oParams).then(function (response) {
      if (response.status) {
        var data = response.data.data;
        var n = 0;
        for (var i in data) {
          data[i].visible = true;
        }

        context.commit("setList", { data: data, total: response.data.total });
        return context.commit("setPagination", page_options);
      }
    });
  },

  load_by_id({ commit }, params) {
    var path = "person/" + params.id;
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        commit("addPerson", data);
        return data;
      }
    });
  },

  loadParticipantDocuments({ commit }, params) {
    var path = "person/documents/" + params.id + "/event/" + params.event_id;
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data;
        return data;
      }
    });
  },

  changeParticipantDocumentStatus(context, data) {
    return api
      .post("person/" + data.id + "/event/" + data.event + "/document/status", {
        key: data.key,
        status: data.status,
        url: data.url,
      })
      .then(function (response) {
        if (response.status) {
          return true;
        }
      });
  },

  rejectParticipantDocument(context, data) {
    return api
      .post("person/" + data.id + "/event/" + data.event + "/document/reject", {
        key: data.key,
        reject: data.reject,
      })
      .then(function (response) {
        if (response.status) {
          return true;
        }
      });
  },

  upload(context, data) {
    var person = { ...data.data };
    person.event = data.event;
    var params = data.params;
    var path =
      typeof person.id !== "undefined"
        ? "person/" + person.id + "/update"
        : "person/add";
    return api.post(path, person).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        context.commit("addPerson", data);
        return data.id;
      }
    });
  },

  upload_role(context, data) {
    var person_role = { ...data.data };
    person_role.event = data.event;

    var roleUpload = {};
    data.params.forEach((param) => {
      roleUpload[param.param] = person_role[param.param];
    });

    var path = "person/" + data.id + "/rel/" + data.role_id + "/edit";
    return api
      .post(path, { data: JSON.stringify(roleUpload) })
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
          return data.id;
        }
      });

    return true;
  },

  addRelationship({ commit }, data) {
    return api
      .post("person/" + data.id + "/add_rel", data.data)
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          return commit("addPerson", data);
        }
      });
  },

  removeRelationship({ commit }, data) {
    return api
      .get("person/" + data.person_id + "/" + data.relation_id + "/remove_rel")
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          return commit("addPerson", data);
        }
      });
  },

  remove(context, id) {
    return api.post("person/" + id + "/remove", {}).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        context.commit("removePerson", id);
      }
    });
  },

  remove_participant(context, params) {
    return api
      .post(
        "person/" + params.id + "/participant/" + params.event_id + "/remove",
        {}
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("removePerson", params.id);
        }
      });
  },

  existsDNI(context, params) {
    return api.post("person/validate_dni", params).then((response) => {
      if (response.status) {
        return response.data;
      } else {
        // TODO SHOW ERROR CONNECTION
      }
    });
  },

  search(content, params) {
    return api.post("person/search", params).then(function (response) {
      if (response.status) {
        var data = response.data;

        return data;
      }
      return false;
    });
  },

  changeStatus(context, params) {
    return api
      .post("person/" + params.id + "/update/status/" + params.event_id, {
        status: params.status,
      })
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
        }
      });
  },

  changeStatusParticipant(context, params) {
    return api
      .post(
        "person/" + params.id + "/event/" + params.event_id + "/update/status",
        { status: params.status, contact_type_id: 10 }
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
        }
      });
  },
  changeStatusParticipantEvent(context, params) {
    return api
      .post(
        "person/" +
          params.id +
          "/event/" +
          params.event_id +
          "/update/role/status",
        { status: params.status }
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
        }
      });
  },

  changeLotterySend(context, params) {
    return api
      .post(
        "person/" +
          params.id +
          "/event/" +
          params.event_id +
          "/update/lottery/send",
        { lottery_send: params.lottery_send }
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
        }
      });
  },

  changeBus(context, params) {
    return api
      .post(
        "person/" + params.id + "/event/" + params.event_id + "/update/bus",
        { bus: params.bus }
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
        }
      });
  },

  changeModality(context, params) {
    return api
      .post(
        "person/" +
          params.id +
          "/event/" +
          params.event_id +
          "/update/modality",
        { modality: params.modality }
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
        }
      });
  },

  changeShirtSize(context, params) {
    return api
      .post(
        "person/" + params.id + "/event/" + params.event_id + "/update/shirts",
        { shirt_size: params.shirt_size }
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
        }
      });
  },

  assignParticipantCampus(context, params) {
    return api
      .post(
        "person/" +
          params.participant_id +
          "/event/" +
          params.event_id +
          "/add/role",
        {
          campus_id: params.week_id,
          contact_type_id: params.contact_type_id,
          status: 11,
        }
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
        }
      });
  },

  assignParticipantCampusNewEvent(context, params) {
    return api
      .post(
        "person/" +
          params.participant_id +
          "/new_event/" +
          params.event_id +
          "/add/role",
        {
          campus_id: params.week_id,
          contact_type_id: params.contact_type_id,
          event_id: params.new_event_id,
          status: 11,
        }
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
        }
      });
  },

  removeParticipantCampus(context, params) {
    return api
      .post(
        "person/" +
          params.participant_id +
          "/event/" +
          params.event_id +
          "/update/role/" +
          params.role_id,
        { status: -1 }
      )
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addPerson", data);
        }
      });
  },

  sendImageRight: (context, params) => {
    return api
      .get(
        "sign/image-right/" +
          params.type +
          "/" +
          params.id +
          "/" +
          params.event_id
      )
      .then((response) => {
        console.log(response);
        return true;
      });
  },
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  addPerson(state, person) {
    var list = { ...state.list };
    list[person.id] = person;

    state.list = list;
  },

  removePerson(state, id) {
    var list = { ...state.list };
    delete list[id];

    state.list = list;
  },

  addNote(state, { id, note }) {
    var list = { ...state.list };
    list[id].notes[note.id] = note;

    state.list = list;
  },

  removeNote(state, { id, note }) {
    var list = { ...state.list };
    delete list[id].notes[note];

    state.list = list;
  },

  applyFilters(state, filters) {
    // var filters = data.filters;
    // var event = data.event;

    // // console.log(getters.getList)

    // var list = { ...state.list };
    // if (!filters) {
    //   for (var i in list) {
    //     list[i].visible = true;
    //   }
    // } else {
    //   for (var i in list) {
    //     list[i].visible = false;
    //   }
    //   for (var i in list) {
    //     var item = list[i];
    //     // console.log(' ---- ITEM ' + item.name + ' --- ')
    //     // console.log(item)
    //     var bFound = true;
    //     var bCampusFound = typeof filters["campus"] === "undefined";
    //     var bCampusDateFound = typeof filters["campus_date"] === "undefined";
    //     for (var k in filters) {
    //       // console.log( "--- KEY: " + k + " ---" )
    //       // var item_value = ( item[k] != null && typeof item[k] == 'object' )? item[k].id : item[k];
    //       // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] );
    //       // var regexp = new RegExp( filters[k].trim(), "gi" );
    //       // if( item.hasOwnProperty( k ) && typeof item[k] == 'object' && filters[ k ] != item_value ) {
    //       //   bFound = false;
    //       // }
    //       // else if( item.hasOwnProperty( k ) && typeof item[k] !== 'object' && !item_value.match( regexp ) ){
    //       //     bFound = false;
    //       // }
    //       if (filters[k] != -1) {
    //         var item_value =
    //           item[k] != null &&
    //           typeof item[k] === "object" &&
    //           !Array.isArray(item[k])
    //             ? item[k].id
    //             : item[k];
    //         // console.log(list)
    //         if (
    //           item.hasOwnProperty(k) &&
    //           filters[k] == null &&
    //           item_value == null
    //         ) {
    //         } else {
    //           //   console.log('KEY SEARCH: ' + k + ' ITEM: ' + item_value + ' - FILTER: ' + filters[k] + ' ' + typeof filters[k])
    //           // filters[k] = filters[k] == null ? null : ( typeof filters[k] !== 'string' ? ( typeof filters[k] !== 'boolean' ? ( filters[k] ? 1 : 0 ) : filters[k] ) : filters[k].trim() )

    //           if (filters[k] != null && typeof filters[k] === "boolean")
    //             filters[k] = filters[k] ? 1 : 0;
    //           else if (filters[k] != null && typeof filters[k] === "string")
    //             filters[k] = filters[k].trim();

    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           var regexp = new RegExp(filters[k], "gi");

    //           if (k == "campus") {
    //             item.current_roles.forEach(role => {
    //               if (
    //                 role.event.id == event &&
    //                 role.contact_type.id == 10 &&
    //                 role.campus.id == filters[k]
    //               ) {
    //                 bCampusFound = true;
    //               }
    //             });
    //           } else if (k == "campus_date") {
    //             item.campus_date.forEach(campus => {
    //               if (campus == filters[k]) bCampusDateFound = true;
    //             });
    //           } else {
    //             if (
    //               item.hasOwnProperty(k) &&
    //               typeof item[k] === "object" &&
    //               filters[k] != item_value
    //             ) {
    //               bFound = false;
    //             } else if (
    //               item.hasOwnProperty(k) &&
    //               typeof item[k] !== "object" &&
    //               !item_value.match(regexp)
    //             ) {
    //               bFound = false;
    //             }
    //           }
    //         }
    //       }
    //     }

    //     list[i].visible = bFound && bCampusFound && bCampusDateFound;
    //   }
    // }

    // state.list = list;
    state.current_filters = filters;
  },

  setCampusSelected(state, campus) {
    state.campus_selected = campus;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
